var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"communityComment"},[_c('div',{staticClass:"CLUBCMT",attrs:{"id":"CLUBCMT","sid":_vm.commontId}})])}
var staticRenderFns = []

export { render, staticRenderFns }